import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { WalletPasswordResetIcon } from '~/img';
import PasswordResetSuccessPanel from '../components/PasswordResetSuccessPanel';
import { Typography } from 'antd';
import { Space, ApplicationStoreLink } from '~/components';
import theme from '~/theme';

const WalletUser: FC = () => {
  const { t } = useTranslation('passwordReset');

  return (
    <PasswordResetSuccessPanel title={t('I am a Wallet User')} icon={<WalletPasswordResetIcon />}>
      <Container>
        <Space direction="vertical" size={5}>
          <Typography.Text className="PasswordResetViaApp-Title">
            {t('Log in with the wallet app')}
          </Typography.Text>
          <div className="PasswordResetViaApp-LinksContainer">
            <ApplicationStoreLink type="google" />
            <ApplicationStoreLink type="apple" />
          </div>
        </Space>
      </Container>
    </PasswordResetSuccessPanel>
  );
};

const Container = styled.div`
  .PasswordResetViaApp-Title {
    color: ${theme.disabledColor};
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .PasswordResetViaApp-LinksContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
`;

export default WalletUser;
